exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tf_title_dialog[data-v-8e308fbe] {\n  text-overflow: ellipsis;\n  width: calc(100% - 180px);\n  overflow: hidden;\n  white-space: nowrap;\n}\n.file-select > .select-button[data-v-8e308fbe] {\n  padding: 1rem;\n  color: white;\n  background-color: #2EA169;\n  border-radius: .3rem;\n  text-align: center;\n  /* font-weight: bold; */\n  cursor: pointer;\n}\n.file-select > input[type=\"file\"][data-v-8e308fbe] {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-8e308fbe","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheezy/WzDialogImportPDF.vue
// module id = U+vb
// module chunks = 1